/** The maker's yes or stop to Iris's proposal (#99). Pure: words, the voice threshold and Iris's replies. */

const YES = new Set(["ja", "jazeker", "doe maar", "akkoord", "prima", "ga je gang", "yes", "go ahead", "ok", "okay", "sure"]);
const STOP = new Set(["nee", "stop", "wacht", "niet", "no", "wait", "cancel"]);
/** A spoken or typed yes starts a step up to this price; above it, or when the price is unknown, only a tap does. */
export const VOICE_LIMIT_USD = 2;
export const COUNTDOWN_SECONDS = 5;
/** The countdown names what starts and what it costs, so a yes meant for something else is caught in time. */
export function countdownText(label: string, priceUsd: number | null): string {
  const what = priceUsd ? `${label} · ${priceLabel(priceUsd)}` : label;
  return `Starting “${what}” in ${COUNTDOWN_SECONDS} seconds — say stop to cancel.`;
}

/** Only a whole-message answer counts: "ja maar eerst de cast" is a question for Iris, not a yes. */
export function consentWord(text: string): "yes" | "stop" | null {
  const answer = text.trim().toLowerCase().replace(/[.!]+$/, "").trim();
  if (YES.has(answer)) return "yes";
  if (STOP.has(answer)) return "stop";
  return null;
}

export function voiceMayStart(priceUsd: number | null): boolean {
  return priceUsd !== null && priceUsd >= 0 && priceUsd <= VOICE_LIMIT_USD;
}

export function priceLabel(priceUsd: number): string {
  return `$${priceUsd.toFixed(2)}`;
}

/** The same sentence the studio says when the month's budget is too small (#99). */
export function budgetReply(priceUsd: number, leftUsd: number): string {
  // Need rounded up, left rounded down: the sentence never reads as if it fits (the server says the same).
  const need = Math.ceil(priceUsd * 100 - 1e-6) / 100, left = Math.floor(leftUsd * 100 + 1e-6) / 100;
  return `This needs ${priceLabel(need)}; ${priceLabel(left)} is left this month.`;
}

/** Over the remaining budget: Iris says so before any countdown or tap. */
export function overBudget(priceUsd: number | null, leftUsd: number | undefined): boolean {
  return !!priceUsd && leftUsd !== undefined && priceUsd > leftUsd + 1e-9;
}

export function consentReply(priceUsd: number | null): string {
  if (priceUsd === null) return "This step shows its price first. Tap “Show me the price”.";
  const price = priceLabel(priceUsd);
  return `This costs about ${price}. Tap “Yes, go ahead · ${price}” to start.`;
}
